import type { Environment } from '../entities/enums';

export const API_ENDPOINT_PAYMENTS_SERVICE_2C2P: Record<Environment, string> = {
  dev: 'https://payments-2c2p.staging.cloud.seek.com.au/',
  staging: 'https://payments-2c2p.staging.cloud.seek.com.au/',
  production: 'https://payments-2c2p.cloud.seek.com.au/',
};
